import { mapActions, mapGetters } from 'vuex';
import chevronIcon from '@/components/icons/chevron-icon.vue';
import sushiMarketDiscussionWidget from '@/components/pages/page-market-detail-sushi/components/sushi-market-discussion-widget/sushi-market-discussion-widget.vue';
import pinSettingsMainMenu from '@/components/pinning/pin-settings-main-menu/pin-settings-main-menu.vue';
import pinboardBiggestGains from '@/components/pinning/pinboard-biggest-gains/pinboard-biggest-gains.vue';
import pinboardBiggestLosses from '@/components/pinning/pinboard-biggest-losses/pinboard-biggest-losses.vue';
import pinboardNewArrivals from '@/components/pinning/pinboard-new-arrivals/pinboard-new-arrivals.vue';
import { getPortfolioSortParts } from '@/components/pinning/pinboard-portfolio-sort';
import PINBOARD_REGISTRY from '@/components/pinning/pinboard-registry.js';
import pinboardSessionHistory from '@/components/pinning/pinboard-session-history/pinboard-session-history.vue';
import pinboardWatchlist from '@/components/pinning/pinboard-watchlist/pinboard-watchlist.vue';
import pinboardWidgetSettingsMenu from '@/components/pinning/pinboard-widget-settings-menu/pinboard-widget-settings-menu.vue';
import widgetPortfolio from '@/components/widget-portfolio/widget-portfolio.vue';
import ls from '@/helpers/localStorage';
import { WIDGET_STATUS } from '@/store/modules/widgets';

const SECTION_MAP = PINBOARD_REGISTRY.reduce((acc, group) => {
  group.widgets.forEach((w) => {
    acc[w.name] = { name: w.name, title: w.title };
  });
  return acc;
}, {});

export default {
  data() {
    return {
      trayOpen: ls.get(`pinboard-tray-${this.side}`, false),
    };
  },
  created() {
    this.settingsMenuRefs = {};
  },
  components: {
    pinboardNewArrivals,
    pinboardBiggestGains,
    pinboardBiggestLosses,
    sushiMarketDiscussionWidget,
    pinboardWatchlist,
    pinboardSessionHistory,
    pinSettingsMainMenu,
    widgetPortfolio,
    chevronIcon,
    pinboardWidgetSettingsMenu,
  },
  props: {
    showMenu: Boolean,
    hideWhenNoItemsSelected: Boolean,
    singlePanel: Boolean,
    side: {
      type: String,
      required: true,
      validator: (v) => ['left', 'right'].includes(v),
    },
  },
  computed: {
    ...mapGetters('pinning', ['getSectionsForPanel', 'isOpened', 'getWidgetSort']),
    ...mapGetters('widgets', ['getWidget']),
    ...mapGetters('user', ['isLoggedIn']),

    sections() {
      if (this.singlePanel) {
        const seen = new Set();
        return ['left', 'right']
          .reduce((acc, p) => acc.concat(this.getSectionsForPanel(p)), [])
          .filter((n) => !seen.has(n) && seen.add(n))
          .map((n) => SECTION_MAP[n])
          .filter(Boolean);
      }
      return this.getSectionsForPanel(this.side)
        .map((n) => SECTION_MAP[n])
        .filter(Boolean);
    },
    portfolioPositionsCount() {
      const markets = this.getWidget('portfolio').data || [];
      return markets.reduce((sum, market) => sum + (market.marketContracts || []).length, 0);
    },
    isPortfolioCountKnown() {
      const { status } = this.getWidget('portfolio');
      return (
        this.isLoggedIn &&
        [WIDGET_STATUS.SUCCESS, WIDGET_STATUS.EMPTY, WIDGET_STATUS.REFRESHING].includes(status)
      );
    },
    portfolioSortParts() {
      const parts = getPortfolioSortParts(this.getWidgetSort('portfolio'));
      if (!this.isPortfolioCountKnown) return parts;
      const count = this.portfolioPositionsCount;
      return [...parts, `${count} position${count === 1 ? '' : 's'}`];
    },
  },
  methods: {
    ...mapActions('pinning', ['toggleOpenPinSection', 'reorderWidget']),
    sectionKey(section) {
      return section.name;
    },
    sectionClassModifiers(section) {
      return {
        'pinboard-panel__section': true,
        'pinboard-panel__section--opened': this.isOpened(this.sectionKey(section)),
      };
    },
    toggleSection(section) {
      this.toggleOpenPinSection(this.sectionKey(section));
    },
    isFirstSection(section) {
      return this.sections.length > 0 && this.sections[0].name === section.name;
    },
    isLastSection(section) {
      return (
        this.sections.length > 0 && this.sections[this.sections.length - 1].name === section.name
      );
    },
    moveWidgetUp(section) {
      this.reorderWidget({ panel: this.side, widget: section.name, direction: 'up' });
    },
    moveWidgetDown(section) {
      this.reorderWidget({ panel: this.side, widget: section.name, direction: 'down' });
    },
    toggleTray() {
      this.trayOpen = !this.trayOpen;
      ls.set(`pinboard-tray-${this.side}`, this.trayOpen);
    },
    setSettingsMenuRef(section, el) {
      this.settingsMenuRefs[this.sectionKey(section)] = el;
    },
    onSortIndicatorClick(section) {
      const menu = this.settingsMenuRefs[this.sectionKey(section)];
      if (menu) menu.toggleMenu();
    },
  },
};
